/* everstory-cart-upsell.js — the in-drawer tier-upgrade nudge.
   The button (rendered by snippets/everstory-upsell.liquid) swaps the cart's
   current tier for the next one up while carrying the Photo N line-item
   properties + quantity across, then re-renders Dawn's cart drawer in place.
   Uses event delegation so it survives the drawer's innerHTML re-renders. */
(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds(drawer) {
    try {
      return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    } catch (e) {
      return 'cart-drawer,cart-icon-bubble';
    }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function track(name, payload) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, payload || {});
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-everstory-upgrade]');
    if (!btn) return;
    e.preventDefault();

    var box = btn.closest('[data-everstory-upsell]');
    if (!box || box.dataset.busy) return;
    box.dataset.busy = '1';
    btn.disabled = true;
    btn.classList.add('is-loading');

    var curId = box.dataset.currentId;
    var curLine = parseInt(box.dataset.currentLine, 10) || 0;
    var nextId = parseInt(box.dataset.nextId, 10);
    var qty = parseInt(box.dataset.nextQty, 10) || 1;
    var drawer = getDrawer();
    var secs = drawer ? sectionIds(drawer) : 'cart-drawer,cart-icon-bubble';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function fail() {
      box.dataset.busy = '';
      btn.disabled = false;
      btn.classList.remove('is-loading');
      window.location.reload();
    }

    // 1. read the current line's photo properties so they ride to the new tier
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        var item = state.items[curLine - 1];
        var props = item && item.properties ? item.properties : {};
        var clean = {};
        Object.keys(props).forEach(function (k) {
          // keep visible props + our hidden _Photo N urls; drop other private keys
          if (k.charAt(0) !== '_' || k.indexOf('_Photo ') === 0) clean[k] = props[k];
        });
        // 2. add the upgraded variant carrying the same photos + quantity
        return postJSON(root + 'cart/add.js', { items: [{ id: nextId, quantity: qty, properties: clean }] });
      })
      // 3. remove the old tier line, asking for the drawer sections back
      .then(function () {
        return postJSON(root + 'cart/change.js', { id: curId, quantity: 0, sections: secs });
      })
      .then(function (parsed) {
        track('everstory_tier_upgrade', { from_variant: curId, to_variant: nextId });
        if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
          drawer.renderContents(parsed);
        } else {
          window.location.reload();
        }
      })
      .catch(fail);
  });
})();
